<script lang="ts">
  import EmployeeDashboard from '../../components/employee/dashboard/EmployeeDashboard.svelte';
</script>

<div class="employee-dashboard-page">
  <EmployeeDashboard />
</div>

<style>
  .employee-dashboard-page {
    min-height: 100vh;
    background-color: #f8fafc;
  }
</style> 